export type ResponseItem = {
  type: 'bullets';
  value: string[];
} | {
  type: 'text';
  value: string;
} | {
  type: 'numbered';
  value: string[];
};

const bulletCharacters = ['*', '-', '•'];

function parseNumberedInput(input: string) {
  const regex = /^\d+\.\s*(.*)/;
  const match = input.match(regex);

  if (match) {
    return match;
  }

  return null;
}

function flushBuffers(lineItems: ResponseItem[], bulletBuffer: string[], numberBuffer: string[]) {
  if (bulletBuffer.length) {
    lineItems.push({ type: 'bullets', value: [...bulletBuffer] });
    bulletBuffer.length = 0;
  }
  if (numberBuffer.length) {
    lineItems.push({ type: 'numbered', value: [...numberBuffer] });
    numberBuffer.length = 0;
  }
}

function processLine(line: string, lineItems: ResponseItem[], bulletBuffer: string[], numberBuffer: string[]) {
  const isBulletedItem = line.length && bulletCharacters.includes(line[0]);

  if (isBulletedItem) {
    bulletBuffer.push(line.length > 1 && line[1] === ' ' ? line.slice(2) : line.slice(1));
    return;
  }

  const parsed = parseNumberedInput(line);
  if (parsed) {
    numberBuffer.push(parsed[1]);
    return;
  }

  if (bulletBuffer.length) {
    lineItems.push({ type: 'bullets', value: [...bulletBuffer] });
    bulletBuffer.length = 0;
  } else if (numberBuffer.length && !!line.length) {
    lineItems.push({ type: 'numbered', value: [...numberBuffer] });
    numberBuffer.length = 0;
  } else if (!numberBuffer.length) {
    lineItems.push({ type: 'text', value: line });
  }
}

export function parseResponse(value: string) {
  const lines = value.split('\n');
  const lineItems: ResponseItem[] = [];
  const bulletBuffer: string[] = [];
  const numberBuffer: string[] = [];

  for (const line of lines) {
    processLine(line, lineItems, bulletBuffer, numberBuffer);
  }

  flushBuffers(lineItems, bulletBuffer, numberBuffer);

  return lineItems;
}
